import { useTranslation } from "react-i18next";
import { translate as tr } from "../../i18n";
import React, { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import '../../assets/css/workflow.css';

function fmtDate(value) {
  if (!value) return '--';
  return new Date(value).toLocaleDateString([], { month: 'short', day: 'numeric' });
}

export default function WorkflowQueueCard({ workspaceId, token, title = 'Workflow Queue', actionLabel = 'Open Leave', actionUrl = '/leave' }) {
  useTranslation();
  const [data, setData] = useState({ summary: {}, issues: [] });
  const [loading, setLoading] = useState(false);

  const authHeaders = useMemo(() => ({
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  }), [token]);

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      if (!workspaceId || !token) return;
      setLoading(true);
      try {
        const res = await axios.get(`/api/workflow/overview?workspace_id=${workspaceId}`, authHeaders);
        if (mounted) {
          setData({
            summary: res.data.summary || {},
            issues: res.data.issues || [],
          });
        }
      } catch (err) {
        if (mounted) setData({ summary: {}, issues: [] });
      } finally {
        if (mounted) setLoading(false);
      }
    };
    load();
    return () => { mounted = false; };
  }, [workspaceId, token, authHeaders]);

  const summary = data.summary || {};
  const topIssues = (data.issues || []).slice(0, 4);

  return (
    <div className="wf-card">
      <div className="wf-card__head">
        <div>
          <div className="wf-card__kicker">{tr("Unresolved work")}</div>
          <h3>{title}</h3>
        </div>
        <Link to={actionUrl} className="wf-card__link">{actionLabel}</Link>
      </div>

      <div className="wf-card__stats">
        <div className="wf-stat">
          <strong>{summary.open_issues || 0}</strong>
          <span>{tr("Open")}</span>
        </div>
        <div className="wf-stat">
          <strong>{summary.critical_issues || 0}</strong>
          <span>{tr("Critical")}</span>
        </div>
        <div className="wf-stat">
          <strong>{summary.warning_issues || 0}</strong>
          <span>{tr("Warnings")}</span>
        </div>
      </div>

      <div className="wf-card__list">
        {loading ? (
          <div className="wf-empty">{tr("Loading queue...")}</div>
        ) : topIssues.length === 0 ? (
          <div className="wf-empty">{tr("No open issues.")}</div>
        ) : (
          topIssues.map((issue) => (
            <div className="wf-item" key={issue.id}>
              <div className={`wf-item__badge wf-item__badge--${issue.severity === 'critical' ? 'critical' : 'warning'}`}>
                {issue.severity === 'critical' ? tr("Critical") : tr("Warning")}
              </div>
              <div className="wf-item__body">
                <strong>{issue.title}</strong>
                <span>{issue.user ? `${issue.user.first_name || ''} ${issue.user.last_name || ''}`.trim() || issue.user.email : tr("Workspace")}</span>
              </div>
              <div className="wf-item__meta">
                <span>{fmtDate(issue.due_at || issue.created_at)}</span>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
